"use client";

import Image from "next/image";
import Link from "next/link";
import rightArrow from "../../../public/assets/icons/east.svg";
import { TickerTape } from "react-ts-tradingview-widgets";
import { useEffect, useState } from "react";
import { getTradingPair } from "@/service/api";

const TopCrypto = () => {
  const [pairs, setPairs] = useState();
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    fetchTradingPairs();
  }, [""]);

  const fetchTradingPairs = async () => {
    // setIsLoading(true);
    let params: any = {
      page: 1,
      sizePerPage: 100,
      pagination: false,
    };

    try {
      const response = await getTradingPair(params);
      if (response.status) {
        setPairs(response?.data?.result);
      }
    } catch (error) {
      console.error("Error fetching pairs:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="w-full">
      <div className="mx-auto flex flex-col gap-16 !bg-[#f8f8f8]">
        {/* <div className="flex items-center justify-between">
          <h2 className="text-[45px] leading-[52px] text-primaryText">
            Top Crypto Today
          </h2>
          <Link href="/spot-trade">
            <div className="flex items-center gap-2">
              <h6 className="text-[16px] leading-6 tracking-[0.15px]">
                View all Assets
              </h6>
              <Image 
onContextMenu={(e) => e.preventDefault()}
                src={rightArrow}
                alt=""
                className="h-[16px] w-[16px]"
              ></Image>
            </div>
          </Link>
        </div> */}
        {/* <div className="md:h-[115px] h-[381px] hidden-scroll px-2">
          <div className="flex md:flex-row flex-col md:justify-normal items-center gap-9">
            <Cards cryptoList={pairs} />
          </div>
        </div> */}
        <TickerTape
          colorTheme="light"
          symbols={[
            {
              proName: "BITSTAMP:BTCUSD",
              title: "BTC/USD",
            },
            {
              proName: "BITSTAMP:ETHUSD",
              title: "ETH/USD",
            },
            {
              proName: "BITSTAMP:USDTUSD",
              title: "USDT/USD",
            },
            // {
            //   proName: "BITSTAMP:BNBUSDT",
            //   title: "BNB/USDT",
            // },
            {
              proName: "BITSTAMP:XRPUSD",
              title: "XRP/USD",
            },
            {
              proName: "BITSTAMP:ADAUSD",
              title: "ADA/USD",
            },
            {
              proName: "BITSTAMP:SOLUSD",
              title: "SOL/USD",
            },
            {
              proName: "BITSTAMP:DOTUSD",
              title: "DOT/USD",
            },
            {
              proName: "BITSTAMP:AVAXUSD",
              title: "AVAX/USD",
            },
            {
              proName: "BITSTAMP:SHIBUSD",
              title: "SHIB/USD",
            },
            {
              proName: "BITSTAMP:DOGEUSD",
              title: "DOGE/USD",
            },
            {
              proName: "BITSTAMP:USDCUSD",
              title: "USDC/USD",
            },
            {
              proName: "BITSTAMP:TRXUSD",
              title: "TRX/USD",
            },
            {
              proName: "BITSTAMP:OPUSD",
              title: "OP/USD",
            },
          ]}
        ></TickerTape>
      </div>
    </section>
  );
};

export default TopCrypto;

const Cards = ({ cryptoList }: any) => {
  return (
    <>
      {cryptoList?.map((item: any, index: number) => {
        return (
          <div
            className="px-3 py-4 flex gap-16 top-crypto-card-shadow w-fit rounded-xl"
            key={index}
          >
            <div className="flex gap-2 items-center">
              <Image
                onContextMenu={(e) => e.preventDefault()}
                src={item.fromCoin.image}
                width={25.81}
                height={22.5}
                alt=""
                className="h-[22.5px] w-[25.81px] mx-[9px] my-[4.75px]"
              ></Image>
              <div>
                <h6 className="text-[16px] leading-6 tracking-[0.15px] text-primaryText">
                  {item.fromCoin?.name}
                </h6>
                <p className="text-secondaryText text-[14px] leading-5 tracking-[0.25px]">
                  {item.fromCoin?.symbol + "/" + item.toCoin?.symbol}
                </p>
              </div>
            </div>
            <div className="flex items-start">
              <p className="text-secondaryText text-[14px] leading-5 tracking-[0.25px]">
                {Number(item.currentPrice).toLocaleString("en-IN", {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2,
                })}
              </p>
            </div>
          </div>
        );
      })}
    </>
  );
};
